import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import Close from "@/assets/images/Close";
import useOutsideClickCallback from "hooks/useOutsideClickCallback";
import React, { useEffect, useRef, useState } from "react";
import { useAppSelector } from "@/hooks/useAppSelector";
import { selectLegalAge } from "@/store/cart/selectors";

interface AgeVerificationModalProps {
  showAgeVerification: boolean;
  setShowAgeVerification: (boolean: boolean) => void;
}

const AgeVerificationModal: React.FC<AgeVerificationModalProps> = ({
  showAgeVerification,
  setShowAgeVerification,
}) => {
  const { t } = useTranslation();
  const outsideClickRef = useRef<HTMLDivElement>(null);
  const legalAge = useAppSelector(selectLegalAge);
  const [fadingState, setFadingState] = useState<"fadeIn" | "fadeOut">();

  useEffect(() => {
    if (showAgeVerification) {
      setFadingState("fadeIn");
      const timer = setTimeout(() => {
        setFadingState("fadeOut");
      }, 5000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [showAgeVerification]);

  const onAnimationEnd = () => {
    if (fadingState === "fadeOut") setShowAgeVerification(false);
  };

  const onDismiss = () => {
    setShowAgeVerification(false);
    setFadingState("fadeOut");
  };

  useOutsideClickCallback(outsideClickRef, onDismiss);

  if (!legalAge) return null;

  return (
    <div
      className={fadingState === "fadeIn" ? classNames(styles.fadeIn) : classNames(styles.fadeOut)}
      onAnimationEnd={onAnimationEnd}>
      <div
        ref={outsideClickRef}
        className={classNames(styles.container)}
        data-cy="age-verified-notification">
        <p className={classNames(styles.p)}>{t("mainPage.ageCheckValid", { age: legalAge })}</p>
        <Close onClick={onDismiss} className={styles.close} />
      </div>
    </div>
  );
};

export default AgeVerificationModal;
